import { style } from '@primeuix/styles/accordion';
import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-accordion p-component'
};
var AccordionStyle = BaseStyle.extend({
  name: 'accordion',
  style: style,
  classes: classes
});

export { AccordionStyle as default };
//# sourceMappingURL=index.mjs.map
